export enum TaskViewId {
  Chat = "chat",
  Full = "full",
  Versions = "versions",
}
